module.exports = __webpack_public_path__ + "logo-mollie.90d165acfe709d946af6428dfc167e03.svg";